export const companyConfig = {
  name: '深圳市华医堂大药房有限公司天河区分公司',
  shortName: 'szhyt',
  recordCode: '',
  address: '广州白云区泰信广场泰信智汇直播基地',
  email: '15x_mdfng6onjg@dingtalk.com',
  phone: '020-XXXXXXXX',
  slogan: '健康生活，从心开始',
  description: '专注于健康管理和减肥科技的领先企业',
  foundYear: '2020',
  wechatQRCode: 'https://mp.weixin.qq.com/mp/qrcode?scene=10000004&size=102&__biz=MzkwOTIyMTIzNg==&mid=2247488605&idx=1&sn=b0faddb57f305d99b39330f6b7472aac&send_time=',
  record_code: '粤ICP备2025429457号',
  socialMedia: {
    weibo: 'https://weibo.com/',
    toutiao: 'https://www.toutiao.com/'
  },
  theme: {
    primary: '#00335b',  // 更深更饱和的蓝色，进一步增强对比度
    secondary: '#0288d1',
    accent: '#e1f5fe',
    footer: '#14679f'
  }
};
